import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
import P from '../../../components/Panel.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <P mdxType="P">
一个进程就是一个程序的运行实例。
启动一个程序的时候，操作系统会为该程序创建一块内存，用来存放代码、运行中的数据和一个执行任务的主线程
我们把这样的一个运行环境叫进程。
    </P>
    <P style={{
      background: '#4AC29A'
    }} mdxType="P">
      <p>{`线程是不能单独存在的，共享进程中的数据，它是由进程来启动和管理的。
当一个进程关闭之后，操作系统会回收进程所占用的内存。`}</p>
    </P>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      